import { render, staticRenderFns } from "./InfoRight.vue?vue&type=template&id=72e7bb30&scoped=true&"
import script from "./InfoRight.vue?vue&type=script&lang=js&"
export * from "./InfoRight.vue?vue&type=script&lang=js&"
import style0 from "./InfoRight.vue?vue&type=style&index=0&id=72e7bb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7bb30",
  null
  
)

export default component.exports